import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupContainerComponent } from './popup-container.component';
import { CashbackPopupModule } from '../cashback-popup/cashback-popup.module';
import { ConnectPopupModule } from '../connect-popup/connect-popup.module';
import { CompareOfferPopupModule } from '../compare-offer-popup/compare-offer-popup.module';
import { SharePopupModule } from '../share-popup/share-popup.module';
import { RatingPopupModule } from '../rating-popup/rating-popup.module';
import { SampleDcpModule } from '../sample-dcp/sample-dcp.module';



@NgModule({
  declarations: [
    PopupContainerComponent
  ],
  imports: [
    CommonModule,
    CashbackPopupModule,
    ConnectPopupModule,
    CompareOfferPopupModule,
    SharePopupModule,
    RatingPopupModule,
    SampleDcpModule
  ],
  exports:[PopupContainerComponent]
})
export class PopupContainerModule { }
